module.exports = __webpack_public_path__ + "img/badge-highest-revenue-silver.c8268705.png";